import { Competition } from './competition'
import { Injectable } from '@angular/core'

@Injectable()
export class CompetitionSerializer {
  fromJson(json: any): Competition {
    const competition = json

    return competition
  }

  toJson(competition: Competition): any {
    return {
      ...competition
    }
  }
}
